<div class="modal-overlay" [class.open]="isOpen" (click)="onOverlayClick($event)">
    <div class="modal-container">
        <div class="modal-header">
            <button class="cancel-btn" (click)="onClose()">Cancel</button>
            <h2 class="modal-title">Expense Tracker</h2>
            <button class="save-btn" (click)="onSave()">Save</button>
        </div>

        <div class="modal-body">
            <p class="description">
                Set up accounts and data display period.
            </p>

            <div class="form-group">
                <label class="form-label">Select Accounts</label>
                <div class="input-wrapper" (click)="toggleAccountDropdown($event)">
                    <input type="text" class="form-input" [(ngModel)]="selectedAccounts" readonly>
                    <div class="input-icon">
                        <img class="carret-icon" src="assets/icons/direction-down.svg" alt="dropdown"
                            [style.transform]="isAccountDropdownOpen ? 'rotate(180deg)' : 'rotate(0)'">
                    </div>
                </div>
                <p class="helper-text">Select the accounts for which statistics will be shown.</p>
            </div>

            <div class="form-group">
                <label class="form-label">Start Date</label>
                <div class="input-wrapper" (click)="toggleCalendar('start', $event)">
                    <input type="text" class="form-input" [value]="startDate" readonly>
                    <div class="input-icon">
                        <img class="calendar-icon" src="assets/icons/calendar.svg" alt="calendar">
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label">Final Date</label>
                <div class="input-wrapper" (click)="toggleCalendar('final', $event)">
                    <input type="text" class="form-input" [value]="finalDate" readonly>
                    <div class="input-icon">
                        <img class="calendar-icon" src="assets/icons/calendar.svg" alt="calendar">
                    </div>
                </div>
            </div>
        </div>

        <app-expense-selection-modal *ngIf="isAccountDropdownOpen" [isDropdown]="true"
            (selectionChange)="onAccountSelectionChange($event)" (close)="isAccountDropdownOpen = false">
        </app-expense-selection-modal>

        <app-calendar *ngIf="isCalendarOpen" [selectedDate]="getSelectedDate()" (dateSelect)="onDateSelect($event)"
            (close)="isCalendarOpen = false">
        </app-calendar>
    </div>
</div>